import { Domain, FwVersionContentAndMetadata } from 'src/dtos/version.dto';
import axiosService from './axios-service';

class DomainService {
    public createDomain = async (customerId: number, sid: number, versionId: string, domain: Domain): Promise<FwVersionContentAndMetadata> => {
        const result = await axiosService.post(`/api/firewall/customer/${customerId}/service/${sid}/domain`, {
            ...domain,
            externalId: versionId
        });
        return result?.data;
    };

    public updateDomain = async (customerId: number, sid: number, versionId: string,
        updatedDomain: Domain, originalDomainName: string, originalDomainAction: string): Promise<FwVersionContentAndMetadata> => {
        const result = await axiosService.put(`/api/firewall/customer/${customerId}/service/${sid}/domain`, {
            ...updatedDomain,
            externalId: versionId,
            originalDomainName,
            originalDomainAction
        });
        return result?.data;
    };

    public deleteDomain = async (customerId: number, sid: number, versionId: string, domainName: string, domainAction: string): Promise<FwVersionContentAndMetadata> => {
        const result = await axiosService.delete(`/api/firewall/customer/${customerId}/service/${sid}/domain`, {
            externalId: versionId,
            domainName: domainName,
            domainAction: domainAction
        });
        return result?.data;
    };
}

const domainService = new DomainService();
export default domainService;